import { Component, Input } from "@angular/core";

@Component({
    selector: "app-user-info-card",
    templateUrl: "./user-info-card.component.html",
    styleUrls: ["./user-info-card.component.scss"],
    standalone: false
})
export class UserInfoCardComponent {
  @Input() email: string = "";
  @Input() name: string = "";
  @Input() showTitle: boolean = true;
}
